export default __webpack_public_path__ + "static/media/Helm of the Inconceivable.0059ae82.jpg";